export default __webpack_public_path__ + "static/media/asiacup-melvin.38072604.png";